<template>
    <div class="turbolearn-page-mobile">
        <!-- 移动端菜单按钮 -->
        <div v-if="false" class="mobile-menu-button" @click="toggleMobileMenu" aria-label="菜单">
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar"></div>
        </div>

        <!-- 移动端菜单 -->
        <div v-if="false" class="mobile-menu">
            <div class="mobile-menu-items">
                <a href="/features" @click.prevent="scrollToElement('container'); toggleMobileMenu()">{{
                    $t('index.features') }}</a>
                <!-- <a href="/price" @click.prevent="gopage('price'); toggleMobileMenu()">{{ $t('index.pricing') }}</a> -->
                <a href="/about" @click.prevent="gopage('about'); toggleMobileMenu()">{{ $t('index.about') }}</a>
                <a href="/faq" @click.prevent="gopage('faq'); toggleMobileMenu()">{{ $t('index.faq') }}</a>

                <div class="mobile-language">
                    <div @click="changeLanguage('zh'); toggleMobileMenu()">中文</div>
                    <div @click="changeLanguage('en'); toggleMobileMenu()">English</div>
                </div>

                <div class="mobile-login-button" v-if="notlogin" @click="gologinpage(); toggleMobileMenu()">
                    {{ $t('index.start') }}
                </div>
                <div class="mobile-login-button" v-else @click="gohomepage(); toggleMobileMenu()">
                    {{ $t('index.dashboard') }}
                </div>
            </div>
        </div>

        <header>
            <div class="logo">
                <img @click="scrollToElement('turbolearn-page-mobile')" :src="index_logo" alt="Logo" />
            </div>
        </header>

        <main v-if="showpage">
            <PricePage v-if="showpage == 'price'" />
            <temsservice v-if="showpage == 'TermsService'" />
            <PrivacyPolicy v-if="showpage == 'PrivacyPolicy'" />
            <AboutUs v-if="showpage == 'about'" />
            <FAQ v-if="showpage == 'faq'" />
        </main>

        <main v-if="showpage == ''">
            <div class="features">
                <div class="content">
                    <h1>{{ $t('index.title') }}</h1>
                    <p>{{ $t('index.subtitle') }}</p>
                    <div class="startbox" @click="gologinpage()">
                        <div class="startbtn-button">{{ $t('index.start2') }}</div>
                    </div>
                    <div class="startbox1" v-if="!notlogin">
                        <div>{{ $t('index.start2') }}</div>
                    </div>
                </div>
            </div>

            <div class="particle-container">
                <div v-for="(particle, index) in particles" :key="index" class="particle" :style="{
                    left: particle.x + 'px',
                    top: particle.y + 'px',
                    backgroundColor: particle.color,
                    width: particle.size + 'px',
                    height: particle.size + 'px',
                    opacity: particle.opacity,
                    animationDuration: particle.duration + 's'
                }"></div>
            </div>

            <div class="upload-box">
                <youtubeview />
            </div>

            <div class="colleges">
                <p>{{ $t('index.title2') }}</p>
                <div class="carousel-container">
                    <div class="universities">
                        <img :src="school_1" alt="Columbia" />
                        <img :src="school_2" alt="HKUST" />
                        <img :src="school_3" alt="Manchester" />
                        <img :src="school_4" alt="PolyU" />
                        <img :src="school_5" alt="Sydney" />
                        <img :src="school_6" alt="Toronto" />
                        <img :src="school_7" alt="UBC" />
                        <img :src="school_8" alt="UCL" />
                        <img :src="school_9" alt="UCLA" />
                        <img :src="school_10" alt="Washington" />
                        <img :src="school_1" alt="Columbia" />
                        <img :src="school_2" alt="HKUST" />
                        <img :src="school_3" alt="Manchester" />
                        <img :src="school_4" alt="PolyU" />
                        <img :src="school_5" alt="Sydney" />
                        <img :src="school_6" alt="Toronto" />
                        <img :src="school_7" alt="UBC" />
                        <img :src="school_8" alt="UCL" />
                        <img :src="school_9" alt="UCLA" />
                        <img :src="school_10" alt="Washington" />
                    </div>
                </div>
            </div>

            <div class="container">
                <h1>{{ $t('index.features') }}</h1>
                <div class="testimonials">
                    <div :class="{
                        testimonial: true,
                        testimonial_l: true,
                    }" v-for="testimonial in filteredTestimonials" :key="testimonial.name">
                        <div class="student-info">
                            <img :src="testimonial.iconurl" class="school-logo" :alt="testimonial.name" />
                        </div>
                        <span class="name">{{ testimonial.name }}</span>
                        <p>
                            <strong>{{ testimonial.content1 }}</strong> {{ testimonial.content }}
                        </p>
                    </div>
                </div>
            </div>

            <div class="colleges2" v-if="false">
                <p>{{ $t('index.title3') }}</p>
                <div class="student-walls">
                    <div v-for="(student, index) in $t('students')" :key="'a' + index" class="student-card">
                        <div class="student-card-header">
                            <img :src="student.schoolImage" :alt="student.schoolName" />
                            <div class="student-wall-name-wrap">
                                <div class="student-wall-name">{{ student.name }}</div>
                                <div class="student-wall-namenick">@{{ student.nickname }}</div>
                            </div>
                        </div>
                        <div class="student-wall-para" v-html="student.para"></div>
                    </div>

                    <div v-for="(student, index) in $t('students2')" :key="'b' + index" class="student-card">
                        <div class="student-card-header">
                            <img :src="student.schoolImage" :alt="student.schoolName" />
                            <div class="student-wall-name-wrap">
                                <div class="student-wall-name">{{ student.name }}</div>
                                <div class="student-wall-namenick">@{{ student.nickname }}</div>
                            </div>
                        </div>
                        <div class="student-wall-para" v-html="student.para"></div>
                    </div>
                </div>
            </div>

            <div class="outlinek">
                <div class="logobox">
                    <img :src="ins_logo" alt="Logo" />
                    <img :src="tiktok_logo" alt="Logo" />
                </div>
            </div>
        </main>

        <div class="footer">

            <div class="lista">
                <!-- <a href="/features" @click.prevent="scrollToElement('container')">{{ $t('index.features') }}</a> -->
                <!-- <a href="/price" @click.prevent="gopage('price')">{{ $t('index.pricing') }}</a> -->
                <a href="/terms" @click.prevent="gopage('TermsService')">{{ $t('index.service') }}</a>
                <a href="/privacy" @click.prevent="gopage('PrivacyPolicy')">{{ $t('index.privacy') }}</a>
            </div>
            <span class="footer-title">Copyright © 2025 ZenNyx AI inc. All rights reserved.</span>
        </div>

        <popuplogin ref="pLogin" />

        <!-- 移动端弹窗 -->
        <transition name="popup-fade">
            <div class="mobile-popup-overlay" v-if="showMobilePopup" @click.self="closeMobilePopup">
                <div class="mobile-popup">
                    <div class="mobile-popup-close" @click="closeMobilePopup">×</div>
                    <div class="mobile-popup-content">
                        <h3>For the full experience,<br>try it on a computer</h3>
                        <div class="copy-link-button" @click="copyWebsiteLink" :class="{ 'copied': showCopySuccess }">
                            {{ showCopySuccess ? 'Copied' : 'Copy Link' }}
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import PricePage from "@/views/pages/index_page/pricePage.vue";
import temsservice from "@/views/pages/index_page/temsservice.vue";
import PrivacyPolicy from "@/views/pages/index_page/PrivacyPolicy.vue";
import AboutUs from "@/views/pages/index_page/AboutUs.vue";
import FAQ from "@/views/pages/index_page/FAQ.vue";
import popuplogin from "@/views/popups/popup_login.vue";
import youtubeview from "@/mobile/m_youtube.vue";
import i18n from '@/locale/i18n';

export default {
    name: "EasynoteaiPageMobile",
    components: {
        PricePage,
        temsservice,
        PrivacyPolicy,
        popuplogin,
        youtubeview,
        AboutUs,
        FAQ
    },
    data() {
        return {
            ins_logo: require("@/assets/images/index/ins_logo.jpg"),
            tiktok_logo: require("@/assets/images/index/tiktok_logo.jpg"),

            school_1: require("@/assets/images/index/Columbia.png"),
            school_2: require("@/assets/images/index/HKUST.png"),
            school_3: require("@/assets/images/index/Manchester.png"),
            school_4: require("@/assets/images/index/PolyU.png"),
            school_5: require("@/assets/images/index/Sydney.png"),
            school_6: require("@/assets/images/index/Toronto.png"),
            school_7: require("@/assets/images/index/UBC.png"),
            school_8: require("@/assets/images/index/UCL.png"),
            school_9: require("@/assets/images/index/UCLA.png"),
            school_10: require("@/assets/images/index/Washington.png"),
            banner: require("@/assets/images/index/banner.png"),
            banner2: require("@/assets/images/index/banner5.png"),
            banner1: require("@/assets/images/index/banner7.png"),
            language: require("@/assets/images/index/language.png"),
            index_logo: require("@/assets/images/index/logo.png"),
            notlogin: true,
            showpage: "",
            showMobileMenu: false,
            particles: [],
            colors: ['#ffffff', '#dd98ff', '#8472ff', '#fa3fff', '#191eff'],
            containerWidth: 0,
            containerHeight: 0,
            showDropdown: false, // 控制下拉框显示与隐藏
            showMobilePopup: false, // 控制弹窗显示
            websiteUrl: window.location.origin, // 获取当前网站链接
            showCopySuccess: false, // 显示复制成功提示
        };
    },
    computed: {
        filteredTestimonials() {
            const testimonials = this.$t('testimonials');
            return [1, 2, 3, 4, 5].map(index => testimonials[index]).filter(Boolean);
        }
    },
    mounted() {
        // 在组件创建时访问路由参数
        if (this.$route.params && this.$route.params.pagekey) {
            this.gopage(this.$route.params.pagekey);
        } else {
            this.scrollToElement('turbolearn-page-mobile')
        }

        // 检查登录状态
        this.checkLoginStatus();
        this.containerWidth = window.innerWidth;
        this.containerHeight = window.innerHeight;
        this.generateParticles(100); // 移动端减少粒子数量

        // 监听窗口大小变化，调整容器尺寸
        window.addEventListener('resize', this.handleResize);

        this.$nextTick(() => {
            this.checkPath(this.$route.path);
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        // 切换移动菜单显示状态
        toggleMobileMenu() {
            this.showMobileMenu = !this.showMobileMenu;
            if (this.showMobileMenu) {
                document.body.style.overflow = 'hidden'; // 禁止背景滚动
            } else {
                document.body.style.overflow = ''; // 恢复背景滚动
            }
        },
        checkPath(path) {
            if (path.includes('features')) {
                this.scrollToElement('container');
                return;
            }
            if (path.includes('price')) {
                this.gopage('price');
                return;
            }
            if (path.includes('terms')) {
                this.gopage('TermsService');
                return;
            }
            if (path.includes('privacy')) {
                this.gopage('PrivacyPolicy');
                return;
            }
            if (path.includes('about')) {
                this.gopage('about');
                return;
            }
            if (path.includes('faq')) {
                this.gopage('faq');
                return;
            }
        },
        generateParticles(count) {
            // 减少粒子数量以提高移动端性能
            const actualCount = window.innerWidth < 400 ? Math.min(count, 50) : count;

            for (let i = 0; i < actualCount; i++) {
                this.particles.push({
                    x: Math.random() * this.containerWidth,
                    y: Math.random() * this.containerHeight,
                    size: Math.random() * 2 + 1, // 更小的粒子尺寸
                    color: this.colors[Math.floor(Math.random() * this.colors.length)],
                    opacity: Math.random() * 0.5 + 0.2, // 降低一些不透明度
                    duration: Math.random() * 10 + 10 // 10-20秒的随机动画时长
                });
            }
        },
        handleResize() {
            this.containerWidth = window.innerWidth;
            this.containerHeight = window.innerHeight;
            // 重新生成粒子
            this.particles = [];
            this.generateParticles(100);
        },
        changeLanguage(language) {
            i18n.locale = language;  // 修改 i18n 的 locale
            localStorage.setItem('language', language);
            this.showDropdown = false;  // 选择后关闭下拉框
        },
        checkLoginStatus() {
            // 获取登录状态
            const subid = this.$cookies.get("subid");
            const ulogin = this.$cookies.get("userlogin");
            if (!!subid && subid != "undefined" && ulogin) {
                this.notlogin = false;
            }
        },
        gologinpage() {
            // 显示弹窗而不是跳转
            this.showMobilePopup = true;
            // this.$router.push("/login");
        },
        gohomepage() {
            this.$router.push("/home");
        },
        gopage(page) {
            this.showpage = page;
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        },
        scrollToElement(className) {
            this.showpage = "";
            // 等待DOM更新
            this.$nextTick(() => {
                // 获取指定class的第一个元素
                const element = document.querySelector(`.${className}`);

                if (element) {
                    // 获取元素的位置信息
                    const rect = element.getBoundingClientRect();
                    // 滚动到元素位置
                    window.scrollTo({
                        top: window.pageYOffset + rect.top,
                        behavior: "smooth"
                    });

                    // 可选：给元素添加焦点
                    element.focus({ preventScroll: true });
                }
            });
        },
        // 关闭弹窗
        closeMobilePopup() {
            this.showMobilePopup = false;
        },
        // 复制链接到剪贴板
        copyWebsiteLink() {
            // 尝试使用更兼容的方法
            try {
                // 首先尝试使用现代剪贴板API
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(this.websiteUrl)
                        .then(() => {
                            this.showCopySuccess = true;
                            setTimeout(() => {
                                this.showCopySuccess = false;
                            }, 2000);
                        })
                        .catch(err => {
                            // 如果API失败，尝试备用方法
                            console.log('复制失败:', err);
                            this.fallbackCopyTextToClipboard(this.websiteUrl);
                        });
                } else {
                    // 如果浏览器不支持剪贴板API，使用备用方法
                    this.fallbackCopyTextToClipboard(this.websiteUrl);
                }
            } catch (err) {
                console.error('复制失败:', err);
                this.fallbackCopyTextToClipboard(this.websiteUrl);
            }
        },
        // 备用的复制方法，更兼容移动设备
        fallbackCopyTextToClipboard(text) {
            // 创建临时文本区域
            const textArea = document.createElement("textarea");
            textArea.value = text;

            // 设置样式让它不可见
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";
            textArea.style.top = "-999999px";
            document.body.appendChild(textArea);

            // 保存当前焦点元素
            const focusedElement = document.activeElement;

            // 选择文本并复制
            textArea.focus();
            textArea.select();

            let success = false;
            try {
                success = document.execCommand('copy');
            } catch (err) {
                console.error('Fallback: 复制命令失败', err);
            }

            // 清理并恢复焦点
            document.body.removeChild(textArea);
            if (focusedElement) focusedElement.focus();

            // 无论是否成功，显示已复制提示
            // 这样即使复制失败也给用户反馈
            this.showCopySuccess = true;
            setTimeout(() => {
                this.showCopySuccess = false;
            }, 2000);

            return success;
        },
    },
};
</script>

<style lang="less" scoped>
.turbolearn-page-mobile {
    color: #ffffff;
    font-family: 'Outfit', Arial, sans-serif;
    min-height: 100vh;
    width: 100%;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    overflow-x: hidden;
    position: relative;
    background-color: #090525;
    -webkit-tap-highlight-color: transparent; // 禁止移动端点击高亮

    // 减少粒子数量和动画复杂度提高性能
    .particle-container {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        overflow: hidden;
        z-index: 0;
        pointer-events: none;
        opacity: 0.5; // 降低整体不透明度

        .particle {
            position: absolute;
            border-radius: 50%;
            animation-name: float;
            animation-timing-function: ease-in-out;
            animation-iteration-count: infinite;
            transform: translateY(0);
            will-change: transform; // 性能优化
        }
    }

    @keyframes float {
        0% {
            transform: translateY(0) translateX(0);
        }

        50% {
            transform: translateY(-20px) translateX(-5px);
        }

        100% {
            transform: translateY(0) translateX(0);
        }
    }

    // 移动端菜单按钮 - 更大、更容易点击
    .mobile-menu-button {
        position: fixed;
        top: 15px;
        right: 15px;
        z-index: 1000;
        width: 46px; // 增大尺寸
        height: 46px;
        cursor: pointer;
        background: rgba(81, 67, 255, 0.2);
        border-radius: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-shadow: 0 2px 10px rgba(81, 67, 255, 0.3);

        .bar {
            width: 24px; // 更宽的线条
            height: 2px;
            background-color: white;
            margin: 3px 0;
            border-radius: 2px;
            transition: 0.3s;
        }

        &:active {
            transform: scale(0.95);
            background: rgba(81, 67, 255, 0.3);
        }
    }

    // 移动端菜单 - 改为下拉菜单样式
    .mobile-menu {
        position: fixed;
        top: 70px;
        right: 15px;
        width: auto;
        min-width: 200px;
        max-width: 85%;
        height: auto;
        background: rgba(13, 7, 54, 0.95);
        z-index: 999;
        backdrop-filter: blur(10px);
        border-radius: 15px;
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
        border: 1px solid rgba(255, 255, 255, 0.1);
        padding: 15px 0;
        transition: all 0.3s ease;
        transform-origin: top right;

        .mobile-menu-items {
            display: flex;
            flex-direction: column;
            align-items: stretch;
            padding: 0;

            a {
                margin: 0;
                font-size: 16px;
                font-weight: 500;
                color: white;
                text-decoration: none;
                position: relative;
                padding: 12px 25px;
                transition: all 0.3s;
                text-align: left;

                &:active {
                    background: rgba(255, 255, 255, 0.1);
                }
            }

            .mobile-language {
                display: flex;
                margin: 10px 15px;
                width: auto;
                justify-content: space-between;

                div {
                    margin: 0 3px;
                    cursor: pointer;
                    padding: 8px 15px;
                    border-radius: 8px;
                    background-color: rgba(255, 255, 255, 0.1);
                    transition: 0.3s;
                    font-size: 15px;
                    font-weight: 500;
                    min-width: 70px;
                    text-align: center;

                    &:active {
                        background-color: rgba(255, 255, 255, 0.2);
                    }
                }
            }

            .mobile-login-button {
                margin: 15px;
                padding: 12px 20px;
                border-radius: 10px;
                background: linear-gradient(90deg, #5143ff, #9c49f8, #f15fe2);
                cursor: pointer;
                font-weight: 600;
                font-size: 16px;
                box-shadow: 0 5px 15px rgba(156, 73, 248, 0.3);
                text-align: center;

                &:active {
                    transform: scale(0.95);
                    box-shadow: 0 2px 8px rgba(156, 73, 248, 0.3);
                }
            }
        }
    }

    header {
        padding-top: 25px;
        padding-bottom: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        z-index: 5;

        .logo {
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                width: 60%; // 更大徽标
                cursor: pointer;
            }
        }
    }

    main {
        .features {
            margin-top: 25px;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            z-index: 1;
            padding: 0 25px;

            .content {
                width: 100%;
                text-align: center;

                h1 {
                    font-size: 3rem; // 更大标题
                    font-weight: 700;
                    line-height: 1.3;
                    letter-spacing: -0.5px;
                    text-align: center;
                    margin-bottom: 20px;
                    background: linear-gradient(90deg, #ffffff, #c9b6ff);
                    -webkit-background-clip: text;
                    background-clip: text;
                    -webkit-text-fill-color: transparent;
                    padding: 0 10px;
                }

                p {
                    color: rgb(238, 224, 255);
                    font-size: 24px; // 更大正文
                    line-height: 1.6;
                    letter-spacing: 0;
                    opacity: 0.95;
                    margin: 15px auto 25px;
                    max-width: 340px;
                    padding: 0 5px;
                }
            }

            .startbox {
                margin-top: 30px;
                margin-bottom: 50px;
                display: inline-block;
                position: relative;
                border-radius: 40px;
                box-shadow: 0 5px 20px rgba(156, 73, 248, 0.4);

                .startbtn-button {
                    position: relative;
                    height: auto;
                    padding: 16px 50px; // 更大点击区域
                    border-radius: 40px;
                    border: none;
                    outline: none;
                    color: #fff;
                    font-size: 18px; // 更大字体
                    font-weight: 600;
                    cursor: pointer;
                    background: linear-gradient(90deg, #5143ff, #9c49f8, #f15fe2);
                    transition: all 0.3s;
                    min-width: 220px;
                    text-align: center;

                    &:active {
                        transform: scale(0.97);
                        box-shadow: 0 2px 10px rgba(156, 73, 248, 0.3);
                    }
                }
            }

            .startbox1 {
                visibility: hidden;
            }
        }

        .upload-box {
            width: 90%;
            margin: 20px auto 50px;
            background-color: rgba(30, 30, 46, 0.7);
            border-radius: 20px;
            overflow: hidden;
            box-shadow: 0 15px 30px rgba(0, 0, 0, 0.25);
            position: relative;
            z-index: 2;

            //   border: 1px solid rgba(255, 255, 255, 0.1);
            // 添加底部装饰
            &:after {
                content: '';
                position: absolute;
                bottom: -10px;
                left: 50%;
                transform: translateX(-50%);
                width: 70%;
                height: 5px;
                background: linear-gradient(90deg, rgba(81, 67, 255, 0.2), rgba(156, 73, 248, 0.2), rgba(241, 95, 226, 0.2));
                border-radius: 10px;
            }
        }

        // 学校轮播区域优化
        .colleges {
            text-align: center;
            margin: 60px 0 40px;
            position: relative;
            z-index: 2;
            padding: 0 20px;

            &:before {
                content: '';
                position: absolute;
                top: -30px;
                left: 50%;
                transform: translateX(-50%);
                width: 60px;
                height: 4px;
                background: linear-gradient(90deg, #5143ff, #9c49f8);
                border-radius: 2px;
            }

            p {
                font-size: 21px; // 更大标题
                font-weight: 600;
                margin-bottom: 30px;
                background: linear-gradient(90deg, #ffffff, #d4c3ff);
                -webkit-background-clip: text;
                background-clip: text;
                -webkit-text-fill-color: transparent;
            }

            .carousel-container {
                width: 100%;
                overflow: hidden;
                position: relative;
                padding: 15px 0;

                &::before,
                &::after {
                    content: "";
                    position: absolute;
                    top: 0;
                    width: 70px; // 更宽的渐变
                    height: 100%;
                    z-index: 1;
                }

                &::before {
                    left: 0;
                    background: linear-gradient(to right, rgba(9, 5, 37, 1) 0%, transparent);
                }

                &::after {
                    right: 0;
                    background: linear-gradient(to left, rgba(9, 5, 37, 1) 0%, transparent);
                }
            }

            .universities {
                display: flex;
                width: max-content;
                animation: scroll 30s linear infinite;
                padding: 10px 0;

                img {
                    height: 50px; // 更大学校图标
                    opacity: 0.85;
                    border-radius: 10px;
                    margin: 0 15px;
                    transition: transform 0.3s, opacity 0.3s;
                }
            }

            @keyframes scroll {
                0% {
                    transform: translateX(0%);
                }

                100% {
                    transform: translateX(-50%);
                }
            }
        }

        // 功能卡片区域完全重新设计
        .container {
            color: white;
            padding: 30px 20px 50px;
            position: relative;
            z-index: 2;

            &:before {
                content: '';
                position: absolute;
                top: 0;
                left: 50%;
                transform: translateX(-50%);
                width: 60px;
                height: 4px;
                background: linear-gradient(90deg, #9c49f8, #f15fe2);
                border-radius: 2px;
            }

            h1 {
                text-align: center;
                font-size: 20px; // 更大标题
                font-weight: 700;
                margin: 0 0 35px;
                background: linear-gradient(90deg, #ffffff, #d4c3ff);
                -webkit-background-clip: text;
                background-clip: text;
                -webkit-text-fill-color: transparent;
            }

            .testimonials {
                display: grid;
                grid-template-columns: 1fr;
                gap: 25px;

                .testimonial_l {
                    position: relative;
                    border: 1px solid rgba(245, 225, 255, 0.15);
                    background: rgba(255, 255, 255, 0.05);
                    transition: all 0.3s ease;
                    transform: translateZ(0); // 硬件加速

                    &:active {
                        border: 1px solid #5544f4;
                        background: linear-gradient(to right, rgba(85, 68, 244, 0.2), rgba(146, 78, 240, 0.2), rgba(215, 101, 222, 0.2));
                        transform: translateY(-3px);
                    }

                    &:after {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        z-index: 1;
                        cursor: pointer;
                        border-radius: 20px;
                    }
                }

                .testimonial {
                    position: relative;
                    border-radius: 20px;
                    padding: 25px;
                    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);

                    // 添加视觉层次的卡片装饰
                    &:before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 50%);
                        border-radius: 20px;
                        pointer-events: none;
                    }

                    p {
                        color: rgba(255, 255, 255, 0.9);
                        line-height: 1.7;
                        font-size: 17px; // 更大文本
                        font-weight: normal;
                        padding-bottom: 15px;
                        position: relative;
                        z-index: 2;

                        strong {
                            font-weight: 600;
                            color: #ffffff;
                            font-size: 18px; // 更大重点文本
                        }
                    }

                    .student-info {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin: 5px 0 15px;
                        position: relative;
                        z-index: 2;

                        img {
                            max-height: 45px; // 更大图标
                            padding: 8px 0;
                            opacity: 0.95;
                        }
                    }

                    .name {
                        font-size: 20px; // 更大名称
                        font-weight: 600;
                        display: block;
                        text-align: center;
                        margin: 10px 0;
                        color: #fff;
                        background: linear-gradient(90deg, #ffffff, #e0d0ff);
                        -webkit-background-clip: text;
                        background-clip: text;
                        -webkit-text-fill-color: transparent;
                        position: relative;
                        z-index: 2;
                    }
                }
            }
        }

        // 学生墙区域完全重新设计
        .colleges2 {
            overflow: hidden;
            position: relative;
            padding: 30px 20px 60px;
            z-index: 2;

            &:before {
                content: '';
                position: absolute;
                top: 0;
                left: 50%;
                transform: translateX(-50%);
                width: 60px;
                height: 4px;
                background: linear-gradient(90deg, #f15fe2, #5143ff);
                border-radius: 2px;
            }

            p {
                text-align: center;
                font-size: 24px; // 更大标题
                font-weight: 600;
                margin-bottom: 30px;
                background: linear-gradient(90deg, #ffffff, #d4c3ff);
                -webkit-background-clip: text;
                background-clip: text;
                -webkit-text-fill-color: transparent;
            }

            .student-walls {
                display: flex;
                flex-direction: column;
                align-items: center;

                .student-card {
                    position: relative;
                    height: auto;
                    background: rgba(255, 255, 255, 0.05);
                    border: 1px solid rgba(245, 225, 255, 0.15);
                    border-radius: 20px;
                    padding: 22px;
                    margin-bottom: 25px;
                    transition: all 0.3s;
                    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
                    transform: translateZ(0); // 硬件加速

                    &:active {
                        transform: translateY(-3px);
                        background: rgba(255, 255, 255, 0.08);
                        border: 1px solid rgba(245, 225, 255, 0.25);
                    }

                    // 添加视觉层次感
                    &:before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 50%);
                        border-radius: 20px;
                        pointer-events: none;
                    }

                    &:after {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        z-index: 2;
                        cursor: pointer;
                        border-radius: 20px;
                    }

                    .student-card-header {
                        padding-bottom: 15px;
                        display: flex;
                        align-items: center;
                        position: relative;
                        z-index: 3;

                        img {
                            width: 55px; // 更大头像
                            height: 55px;
                            object-fit: cover;
                            margin-right: 18px;
                            border-radius: 50%;
                            border: 2px solid rgba(245, 225, 255, 0.3);
                            box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
                        }

                        .student-wall-name-wrap {
                            display: flex;
                            flex-direction: column;

                            .student-wall-name {
                                color: rgba(255, 255, 255, 1);
                                font-size: 18px; // 更大名称
                                font-weight: 600;
                                margin-bottom: 6px;
                            }

                            .student-wall-namenick {
                                color: rgba(254, 246, 255, 0.8);
                                font-size: 16px; // 更大次要文本
                            }
                        }
                    }

                    .student-wall-para {
                        width: 100%;
                        word-wrap: break-word;
                        overflow-wrap: break-word;
                        white-space: normal;
                        font-size: 17px; // 更大正文
                        color: rgba(255, 255, 255, 0.9);
                        line-height: 1.7;
                        position: relative;
                        z-index: 3;

                        i {
                            color: rgb(234, 96, 255);
                            font-weight: 600;
                            font-style: normal;
                            font-size: 18px; // 更大强调文本
                        }
                    }
                }
            }
        }
    }

    // 页脚区域重新设计
    .footer {
        margin-top: 30px;
        padding: 40px 20px;
        text-align: center;
        display: flex;
        flex-direction: column;
        background: rgba(13, 7, 54, 0.8);
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        position: relative;
        z-index: 5;

        .footer-title {
            margin-bottom: 25px;
            color: rgba(255, 255, 255, 0.7);
            font-size: 14px;
            line-height: 1.5;
        }

        .lista {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 15px;
            width: 100%;
            max-width: 300px;
            margin: 0 auto 20px;

            a {
                color: rgba(255, 255, 255, 0.6);
                text-decoration: none;
                font-size: 16px; // 更大链接
                padding: 10px 5px;
                cursor: pointer;
                position: relative;
                transition: all 0.3s;
                border-radius: 20px;

                &:active {
                    color: rgba(255, 255, 255, 0.9);
                    background: rgba(255, 255, 255, 0.1);
                }
            }
        }
    }

    // 移动端特有优化
    @media (max-width: 375px) {

        // 较小屏幕手机优化
        main {
            .features {
                .content {
                    h1 {
                        font-size: 28px;
                    }

                    p {
                        font-size: 16px;
                    }
                }

                .startbox .startbtn-button {
                    padding: 15px 40px;
                    font-size: 17px;
                }
            }

            .colleges p,
            .colleges2 p,
            .container h1 {
                font-size: 22px;
            }

            .testimonials .testimonial p {
                font-size: 16px;
            }

            .student-walls .student-card .student-wall-para {
                font-size: 16px;
            }
        }
    }

    // 较大屏幕手机优化
    @media (min-width: 400px) {
        main {
            .features .content {
                h1 {
                    font-size: 26px;
                }

                p {
                    max-width: 360px;
                }
            }

            .colleges .universities img {
                height: 55px;
            }
        }
    }

    // 触摸反馈优化
    .mobile-menu-button,
    .mobile-menu-close,
    .mobile-login-button,
    .mobile-language div,
    .startbox,
    .lista a {
        touch-action: manipulation; // 优化触摸行为
    }

    // 优化在iOS上的元素点击表现
    @supports (-webkit-touch-callout: none) {

        .mobile-menu-button,
        .mobile-menu-close,
        .mobile-login-button,
        .mobile-language div,
        .startbox,
        .lista a {
            -webkit-tap-highlight-color: transparent;

            &:active {
                transform: scale(0.95);
                transition: transform 0.1s;
            }
        }

        // 修复iOS上滚动时的粘滞问题
        .turbolearn-page-mobile {
            -webkit-overflow-scrolling: touch;
        }
    }

    // 适配不同设备尺寸
    @media (max-width: 360px) {

        // 特小屏幕手机优化
        .mobile-menu-items a {
            font-size: 20px;
        }

        .mobile-language div {
            padding: 10px 20px;
            min-width: 80px;
        }

        .mobile-login-button {
            min-width: 180px;
            padding: 14px 30px;
        }

        .startbox .startbtn-button {
            min-width: 180px;
            padding: 14px 40px;
        }
    }

    @media (min-width: 410px) {

        // 较大屏幕优化
        .student-walls .student-card {
            padding: 25px;
        }

        .testimonials .testimonial {
            padding: 28px;
        }

        .startbox .startbtn-button {
            padding: 18px 60px;
        }
    }

    .outlinek {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding: 40px 0;
        position: relative;
        z-index: 2;

        .logobox {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 90%;
            max-width: 300px;
            gap: 30px;

            img {
                width: 45px;
                height: 45px;
                object-fit: contain;
                border-radius: 8px;
                transition: transform 0.3s ease;

                &:active {
                    transform: scale(1.05);
                }
            }
        }
    }

    // 移动端弹窗样式
    .mobile-popup-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.7);
        backdrop-filter: blur(5px);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2000;
    }

    .mobile-popup {
        width: 85%;
        max-width: 320px;
        background: linear-gradient(135deg, rgba(30, 25, 60, 0.95), rgba(15, 10, 40, 0.95));
        border-radius: 20px;
        padding: 25px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
        position: relative;
        border: 1px solid rgba(255, 255, 255, 0.1);

        // 添加底部装饰效果
        // &:after {
        //     content: '';
        //     position: absolute;
        //     bottom: -5px;
        //     left: 50%;
        //     transform: translateX(-50%);
        //     width: 60%;
        //     height: 4px;
        //     background: linear-gradient(90deg, #5143ff, #9c49f8, #f15fe2);
        //     border-radius: 10px;
        //     opacity: 0.7;
        // }
    }

    .mobile-popup-close {
        position: absolute;
        top: 10px;
        right: 15px;
        font-size: 28px;
        color: rgba(255, 255, 255, 0.8);
        cursor: pointer;
        line-height: 1;
        padding: 3px 10px;
        border-radius: 50%;

        &:active {
            background: rgba(255, 255, 255, 0.1);
        }
    }

    .mobile-popup-content {
        display: flex;
        flex-direction: column;
        align-items: center;

        h3 {
            font-size: 20px;
            text-align: center;
            margin-bottom: 25px;
            line-height: 1.4;
            background: linear-gradient(90deg, #ffffff, #d0c0ff);
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        .copy-link-button {
            background: linear-gradient(90deg, #5143ff, #9c49f8);
            border-radius: 12px;
            color: white;
            font-weight: 600;
            font-size: 17px;
            padding: 14px 35px;
            cursor: pointer;
            min-width: 180px;
            text-align: center;
            box-shadow: 0 5px 15px rgba(81, 67, 255, 0.3);
            transition: all 0.3s;

            &.copied {
                background: linear-gradient(90deg, #42c97c, #38a76a);
            }

            &:active {
                transform: scale(0.95);
            }
        }
    }

    // 弹窗动画
    .popup-fade-enter-active,
    .popup-fade-leave-active {
        transition: opacity 0.3s ease;
    }

    .popup-fade-enter-from,
    .popup-fade-leave-to {
        opacity: 0;
    }
}
</style>